/* eslint-disable eqeqeq */
import Util from 'app/scripts/lib/util';
import _ from 'underscore';
import getQueryParamByKey from 'app/scripts/lib/util/url/get-query-param-by-key';
import xtend from 'xtend';

// This is extremely fragile. But these history errors are driving me insane.
// If we ever get a reasonable router -- and some day we may -- then we won't
// need this nonsense. But in the meantime, this prevents incredibly annoying
// bugs like this one:
//
// 1. Open the notifications tab and click a link to a board (not in a comment
//    or anything; in notification text).
// 2. Press the back button.
// 3. Get into an infinite redirect loop.
// 4. Swear off Trello forever.
//
// Feel free to extend this; this only handles the very common cases and is
// nowhere near exhaustive.

const shortLinker = (prefix) =>
  new RegExp(`^/${Util.escapeForRegex(prefix)}/([a-zA-Z0-9]{8})(/|$)`);

const getCardShortLink = (route) => {
  const matches = shortLinker('c').exec(route);
  return matches ? matches[1] : undefined;
};

const getBoardShortLink = (route) => {
  const matches = shortLinker('b').exec(route);
  return matches ? matches[1] : undefined;
};

const nonEmptyAndEqual = (str1, str2) => str1 && str2 && str1 === str2;

const isTheSameAs = function (route1, route2) {
  const card1 = getCardShortLink(route1);
  const card2 = getCardShortLink(route2);
  if (nonEmptyAndEqual(card1, card2)) {
    return true;
  }

  const board1 = getBoardShortLink(route1);
  const board2 = getBoardShortLink(route2);
  if (nonEmptyAndEqual(board1, board2)) {
    return true;
  }

  return false;
};

const iframeSource = getQueryParamByKey('iframeSource');

const getPathWithIframeSource = function (path, _iframeSource) {
  // eslint-disable-next-line no-useless-escape
  if (/\?[^=]+\=[^&]+/.test(path)) {
    // check for existing query parameters
    return `${path}&iframeSource=${_iframeSource}`;
  } else {
    return `${path}?iframeSource=${_iframeSource}`;
  }
};

export const navigateFactory = (
  backboneNavigate,
  locationPathname,
  trackPageview,
) =>
  function (path, options) {
    if (iframeSource != null) {
      path = getPathWithIframeSource(path, iframeSource);
    }

    if (isTheSameAs(path, locationPathname)) {
      options = xtend(options, { replace: true });
    }

    backboneNavigate(path, options);

    const shouldTrack =
      (options != null ? options.shouldTrack : undefined) !== undefined
        ? options != null
          ? options.shouldTrack
          : undefined
        : // This boolean expression is the most accurate `shouldTrack` default for
          // Trello, determined by trial-and-error. It doesn't have an inherent
          // meaning.
          (options != null ? options.replace : undefined) ||
          !(options != null ? options.trigger : undefined);

    if (shouldTrack) {
      trackPageview(path);
    }
  };
